import { gql } from '@apollo/client';

export const DELETE_INSTITUTION = gql`
  mutation deleteInstitution($id: ID!) {
    institution: deleteInstitution(id: $id) {
      id
      name
    }
  }
`;
